<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'transferDate'" v-model="formData.transferDate" :required="isRequired('transferDate')"
                   name="transferDate" label="划账日期"
                   placeholder="划账日期" input-align="right" :disabled="isDisabled('transferDate')"  :rules="getRules('transferDate')">
          <template #input>
            <view-item @click.native="isShowPopup(transferDate,'transferDate')" :value="formData.transferDate"
                       placeholder="请选择划账日期"/>
            <van-calendar v-model="transferDate.show" ref="transferDate" :min-date="transferDate.minDate"
                          :max-date="transferDate.maxDate" :show-confirm="false" title="选择划账日期"
                          @confirm="transferDateConfirm"></van-calendar>
          </template>
        </van-field>
          <van-field v-f-show="'sy'" v-model="formData.sy" :disabled="isDisabled('sy')"
                   :required="isRequired('sy')" :rules="getRules('sy')" name="sy" type="textarea"
                   maxlength="100" rows="3" autosize label="划转事由" show-word-limit
                   placeholder="请输入划转事由" input-align="right"/>
        <van-field
         v-f-show="'transferType'" v-model="formData.transferType" :disabled="isDisabled('transferType')" :required="isRequired('transferType')"
                   name="transferType" label="划转分类"
                   placeholder="划转分类" input-align="right" :rules="getRules('transferType')"
            readonly
            clickable
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
            <van-field v-if="formData.transferType === '产值'" v-f-show="'contract'" v-model="formData.contract" :required="isRequired('contract')" :rules="getRules('contract')"
                   name="contract" label="合同" placeholder="请输入合同" input-align="right">
          <template #input>
            <view-item @click.native="isShowPopup(contract,'contract')" :value="getContractName()" placeholder="请选择合同"/>
          </template>
        </van-field>
         <!--  -->
          <van-field 
            v-f-show="'transferAmount'" 
            v-model="formData.transferAmount" 
            :required="isRequired('transferAmount')"
            :disabled="isDisabled('transferAmount')"
            name="transferAmount" 
            label="划转金额"
            placeholder="划转金额" 
            input-align="right" 
            :maxlength="10"
            @blur="formatTransferAmount($event,formData,'transferAmount')"
            :rules="getRules('transferAmount')"  
            type="number" />
        <van-field v-f-show="'transferFrom'" input-align="right" name="transferFrom" :required="isRequired('transferFrom')"
                   :value="formData.transferFrom" :rules="getRules('transferFrom')" label="转出方" placeholder="请选择转出方">
          <template #input>
           <view-item @click.native="isShowPopup(transferFrom,'transferFrom')" 
           :value="getTransferName('transferFrom')" 
           placeholder="请选择转出方"/>
            <van-popup v-model="transferFrom.show" position="bottom">
              <van-nav-bar title="选择转出方" left-text="取消" right-text="确定" @click-left="transferFrom.show = false"
                           @click-right="businessSelectFinish('transferFrom')"/>
              <van-row type="flex" align="center" class="p-r-20">
                <van-col :span="24">
                  <van-search v-model="transferFrom.filterText" @input="pickerSearch($event,transferFrom,'name', 'columnsLabel')" clearable
                              shape="round"/>
                </van-col>
              </van-row>
              <van-picker :duration="0" ref="transferFrom" value-key="columnsLabel" :columns="transferFrom.filteredData"
                          @cancel="transferFrom.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'transferTo'" input-align="right" name="transferTo" :required="isRequired('transferTo')"
                   :value="formData.transferTo" :rules="getRules('transferTo')" label="转入方" placeholder="请选择转入方">
          <template #input>
           <view-item @click.native="isShowPopup(transferTo,'transferTo')" 
           :value="getTransferName('transferTo')" 
           placeholder="请选择转入方"/>
            <van-popup v-model="transferTo.show" position="bottom">
              <van-nav-bar title="选择转入方" left-text="取消" right-text="确定" @click-left="transferTo.show = false"
                           @click-right="businessSelectFinish('transferTo')"/>
              <van-row type="flex" align="center" class="p-r-20">
                <van-col :span="24">
                  <van-search v-model="transferTo.filterText" @input="pickerSearch($event,transferTo,'name', 'columnsLabel')" clearable
                              shape="round"/>
                </van-col>
              </van-row>
              <van-picker :duration="0" ref="transferTo" value-key="columnsLabel" :columns="transferTo.filteredData"
                          @cancel="transferTo.show = false"/>
            </van-popup>
          </template>
        </van-field>



        <van-field v-f-show="'fj'"   :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" class="filesComponentBox fileValueBox" placeholder="请上传文件" >
          <template #input >
            <!-- <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow" class="filesComponent"></uploadFiles> -->
                          <!-- 引入封装的上传组件 -->
                             <!-- :disabled="isDisabled('fj')" -->
          <!-- <MobileFileUpload
            :files="formData.fj"
            :disabled="isDisabled('fj')"
            @success="uploadSuccess"
            @fileRemove="handleFileRemove" 
          /> -->
 <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow"   @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>


    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <van-notice-bar scrollable
                    text="流程审批须知：请务必留意，审批流程的确定需依据成本归属部门进行。即，成本归属于哪个部门，则需由该部门的相关人员进行审批。"/>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class=""
               :actCurrentNode="processData.actCurrentNode || ''" :flowTraceList="flowTrace"
               :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"
              :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-35">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
    <relativeFlow :show="relativeFlow.show" @finish="relativeFlowFinish"
                  @close="relativeFlow.show = false"></relativeFlow>
   <contract :show="contract.show" @finish="contractFinish" @close="contract.show = false"></contract>
  </div>
</template>
<script>
import {
  getFormDataByInstanceId,
  getRelaveFormDataByInstanceId,
} from '@/api/flow'
import { getDeptUserTreeAll} from '@/api/user.js'
import moment from "moment";

import cache from "@/plugins/cache";
import uploadFiles from "@/components/uploadFiles/index.vue";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import relativeFlow from '@/components/flow/relativeFlow.vue'
import {Dialog, Toast} from 'vant';
import {methodGetApi} from "@/api/publicApi";
import contract from './components/contract.vue'
// import MobileFileUpload from "@/components/uploadFiles/MobileFileUpload.vue"; 
import {formatToTwoDecimals} from "@/utils/ruoyi";
import mixin from '@/mixin/flow'
export default {
  mixins: [mixin],
  components: {uploadFiles, bottomBar, approver, flowTrace, relativeFlow, Dialog,contract},
  data() {
    const _this = this
    return {
      transferDate: {
        show: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date()
      },
      formData: {
        // 申请日期
        transferDate: moment().format('YYYY-MM-DD'), //划账日期 当前日期 格式为yyyy-MM-dd,
        flowNo: '',//编号
        sqr: '',//申请人,
        sy:'',//事由
        fj:[],//附件
        transferType: '',//划转分类
        transferFrom: '',//转出方
        transferTo: '',//转入方
        transferAmount: '',//划转金额
        transferDetail:[{
        transferFrom: '',//转出方
        transferTo: '',//转入方
        transferAmount: '',//划转金额
        }]
     
      },
      formItemMap: null, // 表单字段的Map
      // 关联流程
      relativeFlow: {
        show: false
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
        // 自定义校验数据
      rules: {
      },
      columns: ['产值', '费用'],
      showPicker: false,
      btnLoading: false,
      //转出方
      transferFrom: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
       //转入方
      transferTo: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      contract: {
        show: false
      },//合同
    }
  },
    watch: {
    'formData.transferAmount': {
      handler(nvl) {
        console.log('transferAmount', nvl)
      },
      deep: true
    },
    },
  created() {
   
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init(reSend)
   
  },
  methods: {

     // 可选：文件删除后的额外操作
    handleFileRemove(removedFile) {
      console.log("删除的文件：", removedFile);
      this.formData.fj.forEach((element,index) => {
        if(element.id == removedFile.id){
          this.formData.fj.splice(index,1)
        }
      });
      // 如：调用后端删除接口、更新表单等
    },
    // 进页面就调用
    init(reSend) {
       const _this = this
        if (reSend && this.$route.query.processInstanceId) { // 重新发起时
          this.$loading.show()
          this.getFormInfo({templateId: this.templateId}).then(res => {
            this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
            // 从后台去流程表单数据 只取fomData
            getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
               form.data.transferAmount=this.reserveLength(Number(form.data.transferDetail[0].transferAmount))
           form.data.transferFrom=form.data.transferDetail[0].transferFrom
           form.data.transferTo=form.data.transferDetail[0].transferTo
              // 合并
              Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
              this.$loading.hide()
            })
          })
        } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) {
          // 外部跳转时
          this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
          if (this.$route.query.taskId) {
            this.SET_TASK_ID(this.$route.query.taskId)
          }
          this.$loading.show()
          this.getProcessInfo({
            processInstanceId: this.$route.query.processInstanceId,
            taskId: this.$route.query.taskId
          }).then(res => {
            console.log(res, 'res.data.formData')
            res.data.formData.transferAmount=this.reserveLength(Number(res.data.formData.transferDetail[0].transferAmount))
            res.data.formData.transferFrom=res.data.formData.transferDetail[0].transferFrom
            res.data.formData.transferTo=res.data.formData.transferDetail[0].transferTo
            this.$set(this,'formData', res.data.formData)
            // Object.assign(this.formData, res.data.formData)
            this.$loading.hide()
          })
        } else { // 新增时
          // 新增时调用
          this.getFormInfo({templateId: this.templateId}).then(res => {
            this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
            Object.assign(this.formData, res.data.processTemplates.expressVals)
          })
          // 关联流程跳转时
          if (this.$route.query.isRelevanceFlow) {
            const params = {
              processInstanceId: this.$route.query.destProcessInstanceId,
              destGroupId: this.$route.query.groupId
            }
            getRelaveFormDataByInstanceId(params).then(res => {
              Object.assign(this.formData, res.data)
            })
          }

      }
      this.getBusUnitData()
      this.getDeptUserTreeAll()
    },
    // 划转分类
    getCategoryTree() {
        getCategoryTree().then(res => {
          const data =res.data
          this.$set(this.transferType, 'data', data)
        })
      },
    relativeFlowFinish(data) {
      // 循环遍历this.formData.relativeFlow，添加data中不重复的项目
      data.forEach(item => {
        if (!this.formData.relativeFlow.find(ele => ele.flowNo === item.flowNo)) {
          this.formData.relativeFlow.push(item)
        }
      })
      // this.formData.relativeFlow = data
      this.relativeFlow.show = false
    },
    //附件上传
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
        this.formData.fj = fileList
        console.log(fileList)
    },
    //划账日期
    transferDateConfirm(date) {
      this.formData.transferDate = moment(date).format('YYYY-MM-DD')
      this.transferDate.show = false
    },
    onConfirm(value) {
      this.formData.transferType = value;
      this.showPicker = false;
    },
    // 输入完成后格式化金额
  formatTransferAmount(e,formData,transferAmount) {
    formatToTwoDecimals(formData, transferAmount)
     e.target.value=this.formData.transferAmount
    this.formData.transferDetail[0].transferAmount = this.formData.transferAmount
  },
  //转出方/转入方
  getBusUnitData() {
      methodGetApi('/system/sysBusUnit/list').then(res => {
        const data = res.data.map(item => {
          return {
            ...item,
            columnsLabel: item.unitName // 用于在选择器中显示的名称
          };
        })
        this.transferFrom.data = res.data
        this.transferFrom.filteredData = [...this.transferFrom.filteredData, ...data]
        this.transferTo.data = res.data
        this.transferTo.filteredData = [...this.transferTo.filteredData, ...data]
      })
    },
// 修改 businessSelectFinish 方法，在选择完成后验证
businessSelectFinish(field) {
  const item = this.$refs[field].getValues()[0];
  if (item && item.unitId && item.unitName) {
    // 存储为 unitId,unitName 格式
    const oldValue = this.formData[field]; // 保存当前值
    this.formData[field] = item.unitId + ',' + item.unitName;
    this.formData.transferDetail[0][field]=this.formData[field]
    // 验证转出方和转入方是否相同
    if (!this.validateTransferFromAndTo()) {
      // 如果验证失败，恢复原值
      this.formData[field] = oldValue;
       this.formData.transferDetail[0][field]=oldValue
      return;
    }
    
    this[field].show = false;
  }
},
  // 搜索过滤方法
  pickerSearch(query, field, searchKey, displayKey) {
    if (!query) {
      field.filteredData = field.data;
    } else {
      field.filteredData = field.data.filter(item => 
        item[searchKey] && item[searchKey].toLowerCase().includes(query.toLowerCase())
      );
    }
  },
  // 获取转出方显示名称
  getTransferName(type) {
      if (this.formData[type]) {
        const parts = this.formData[type].split(',');
        return parts[1] || ''; // 返回 unitName
      }
      return '';
    },
    // 验证转出方和转入方是否相同
validateTransferFromAndTo() {
  if (this.formData.transferFrom && this.formData.transferTo) {
    const transferFromId = this.formData.transferFrom.split(',')[0];
    const transferToId = this.formData.transferTo.split(',')[0];
    if (transferFromId === transferToId) {
      Toast('转出方和转入方不能为同一单位');
      return false;
    }
  }
  return true;
},
// 获取合同名称显示
getContractName() {
  if (this.formData.contract) {
    const parts = this.formData.contract.split(',');
    return parts[1] || ''; // 返回 contractName
  }
  return '';
},
  //选择合同
  contractFinish(item) {
    if (!item || item.length === 0) return;
    let contract = item[0].contractId + ',' + item[0].contractName
    this.contract.show = false;
    this.$set(this.formData, 'contract', contract)
  },
 // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.approver, 'data', data)
        })
      })
    },
  }
  

}
</script>
